module.exports = __webpack_public_path__ + "img/symbol_s09.e030775.svg";